import { Component } from "./component.js";
import {
  onDocumentReady,
  changeMetaThemeColor,
  calculateHeaderGroupHeight,
} from "./utilities.js";
class HeaderComponent extends Component {
  requiredRefs = ["headerDrawerContainer", "headerMenu", "headerRowTop"];
  #e = null;
  #t = null;
  #i = !1;
  #s = 0;
  #n = null;
  #o = 150;
  #r = new ResizeObserver(([e]) => {
    if (!e) return;
    const { height: t } = e.target.getBoundingClientRect();
    (document.body.style.setProperty("--header-height", `${t}px`),
      this.#e && window.innerWidth > this.#e && this.#a(!1));
  });
  #c = (e = !0) => {
    if (this.#t) return;
    const t = { threshold: [0, 1], rootMargin: e ? "-1px 0px 0px 0px" : "0px" };
    ((this.#t = new IntersectionObserver(([t]) => {
      if (!t) return;
      const { isIntersecting: i } = t;
      e || (this.#i = !i || "active" === this.dataset.stickyState);
    }, t)),
      this.#t.observe(this));
  };
  #a(e) {
    e
      ? (this.refs.headerDrawerContainer.classList.remove("desktop:hidden"),
        (this.#e = window.innerWidth),
        this.refs.headerMenu.classList.add("hidden"))
      : (this.refs.headerDrawerContainer.classList.add("desktop:hidden"),
        (this.#e = null),
        this.refs.headerMenu.classList.remove("hidden"));
  }
  #d = () => {
    const e = this.getAttribute("sticky");
    if (!this.#i && "always" !== e) return;
    const t = window.pageYOffset || document.documentElement.scrollTop,
      i = t < this.#s,
      s = t > 10;
    if (
      ((this.dataset.stickyState = s ? "active" : "inactive"),
      this.refs.headerRowTop.classList.toggle("main-nav--is-scrolled", s),
      s)
    ) {
      const e = getComputedStyle(this.refs.headerRowTop).backgroundColor;
      changeMetaThemeColor?.(e);
    }
    if ("always" === e)
      return (
        (this.dataset.scrollDirection = t <= 0 ? "none" : i ? "up" : "down"),
        void (this.#s = Math.max(0, t))
      );
    (i
      ? (this.removeAttribute("data-animating"),
        this.getBoundingClientRect().top >= 0
          ? ((this.#i = !1),
            (this.dataset.stickyState = "inactive"),
            (this.dataset.scrollDirection = "none"))
          : ((this.dataset.stickyState = "active"),
            (this.dataset.scrollDirection = "up")))
      : "active" === this.dataset.stickyState
        ? ((this.dataset.scrollDirection = "none"),
          this.setAttribute("data-animating", ""),
          (this.#n = setTimeout(() => {
            ((this.dataset.stickyState = "idle"),
              this.removeAttribute("data-animating"));
          }, this.#o)))
        : ((this.dataset.scrollDirection = "none"),
          (this.dataset.stickyState = "idle")),
      (this.#s = Math.max(0, t)));
  };
  connectedCallback() {
    (super.connectedCallback(), this.#r.observe(this));
    const e = this.getAttribute("sticky");
    (e &&
      (this.#c("always" === e),
      ("scroll-up" !== e && "always" !== e) ||
        document.addEventListener("scroll", this.#d, { passive: !0 })),
      this.#h(),
      this.#l(),
      (this._onCartUpdate = (e) => {
        const t = e;
        void 0 !== t.detail?.cart?.item_count
          ? this.#u(t.detail.cart.item_count)
          : fetch("/cart.js")
              .then((e) => e.json())
              .then((e) => this.#u(e.item_count));
      }),
      document.addEventListener("cart:updated", this._onCartUpdate),
      (this._onOverflow = (e) => {
        const t = e;
        this.#a(t.detail.minimumReached);
      }),
      this.addEventListener("overflowMinimum", this._onOverflow),
      this.#m());
  }
  #l() {
    this.addEventListener(
      "pointerenter",
      (e) => {
        const t = e.target.closest("[data-mega-hover-index]");
        t && this.handleMegaMenuHover(t);
      },
      { capture: !0, passive: !0 },
    );
  }
  #u(e) {
    const t = this.querySelector("[data-cart-count]");
    t &&
      ((t.textContent = e.toString()),
      t.setAttribute("data-count", e.toString()),
      (t.style.display = e > 0 ? "flex" : "none"));
  }
  #m() {
    fetch("/cart.js")
      .then((e) => e.json())
      .then((e) => this.#u(e.item_count))
      .catch(() => {});
  }
  handleMegaMenuHover(e) {
    const t = e.getAttribute("data-mega-hover-index");
    t &&
      (this._hoverTimeout && clearTimeout(this._hoverTimeout),
      (this._hoverTimeout = setTimeout(() => {
        const i = e.closest(".mega-menu");
        if (!i) return;
        const s = i.querySelector("[data-mega-previews]"),
          n = i.querySelector("[data-mega-promos]");
        s &&
          ((s.dataset.activeIndex = t),
          n &&
            (n.classList.add("is-hidden-interactive"),
            s.classList.remove("is-hidden-interactive")));
      }, 50)));
  }
  #h() {
    this.querySelectorAll('details[class*="mobile-nav-"]').forEach((e) => {
      const t = e.querySelector("summary");
      t &&
        t.addEventListener("click", (t) => {
          e.hasAttribute("open") &&
            (t.preventDefault(),
            e.setAttribute("data-closing", "true"),
            setTimeout(() => {
              (e.removeAttribute("open"), e.removeAttribute("data-closing"));
            }, 400));
        });
    });
  }
  toggleMobileMenu(e) {
    const t = `MobileMenu-${this.dataset.sectionId}`,
      i = document.getElementById(t);
    if (!i) return;
    const s = i.classList.toggle("is-active");
    document.body.style.overflow = s ? "hidden" : "";
  }
  openCartDrawer(e) {
    (e && e.preventDefault(),
      document.dispatchEvent(new CustomEvent("cart:open", { bubbles: !0 })));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(),
      this.#r.disconnect(),
      this.#t?.disconnect(),
      document.removeEventListener("scroll", this.#d),
      this._onCartUpdate &&
        document.removeEventListener("cart:updated", this._onCartUpdate),
      this._onOverflow &&
        this.removeEventListener("overflowMinimum", this._onOverflow),
      this._hoverTimeout && clearTimeout(this._hoverTimeout),
      this.#n && clearTimeout(this.#n));
  }
}
(customElements.get("header-component") ||
  customElements.define("header-component", HeaderComponent),
  onDocumentReady(() => {
    const e = document.querySelector("header-component"),
      t = document.querySelector("#header-group");
    if (t && e) {
      const i = () => calculateHeaderGroupHeight(e, t),
        s = new ResizeObserver(i);
      Array.from(t.children).forEach((e) => {
        e instanceof HTMLElement && s.observe(e);
      });
      (new MutationObserver(() => {
        (Array.from(t.children).forEach((e) => {
          e instanceof HTMLElement && s.observe(e);
        }),
          i());
      }).observe(t, { childList: !0 }),
        i());
    }
  }));
